import { guestClient } from '../api/guestClient'

// Shorter than the main client timeout — a hung refresh should fail fast
const REFRESH_TIMEOUT_MS = 10_000

export const refreshTokenApi = async refreshToken => {
  const res = await guestClient.post(
    '/auth/refresh',
    { refresh_token: refreshToken },
    { timeout: REFRESH_TIMEOUT_MS }
  )

  return res.data
}
